import script from "./CommentsSectionDisplayComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentsSectionDisplayComment.vue?vue&type=script&setup=true&lang=ts"

import "./CommentsSectionDisplayComment.vue?vue&type=style&index=0&id=65178f8a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65178f8a"]])

export default __exports__